export enum CustomModelTopicUpdateMethod {
  add = "add",
  delete = "delete",
}
